import { getField, updateField } from 'vuex-map-fields'

export default {
  namespaced: true,
  state: {
    show: false,
    variant: 'error',
    title: '',
    message: 'An error occurred',
    timeout: 0
  },
  getters: {
    getField
  },
  mutations: {
    updateField
  }
}
